import React, { Component } from "react";
// Orden de hojas de estilo: antd -> overrides de modo oscuro -> estilos de la app.
// darkMode.css debe quedar antes de App.css para que cualquier estilo propio
// (misma especificidad) siga ganando en modo oscuro.
import "antd/dist/antd.css";
import "../themes/antdDark.generated.css";
import "../themes/darkMode.css";
import "./Styles/App.css";
import "../themes/chartTheme";
import AppHolder from "./Styles/appComponentStyle";
import HomeContainer from "../containers/HomeContainer";
import MapContainer from "../containers/MapContainer";
// viejo (reemplazado por ScreenDetailView): import ScreenContainer from "../newSrc/shared/containers/ScreenContainer";
import VideoUploadContainer from "../containers/VideoUploadContainer";
// VERSION ACTUAL
// import CampaignManagerContainer from "../containers/CampaignManagerContainer";
// VERSION ACTUAL

// VERSION FINAL
import CampaignManagerView from "../newSrc/views/CampaignManagerView";
// VERSION FINAL

import AdLibraryView from "../newSrc/views/AdLibraryView";

import PaymentContainer from "../containers/PaymentContainer";
import PaymentStatusContainer from "../containers/PaymentStatusContainer";
// viejo (reemplazado por CampaignsManagerView/ProposalsManagerView): import CampaignsContainer from "../containers/CampaignsContainer";
import CampaignsManagerView from "../newSrc/views/CampaignsManagerView";
import ProposalsManagerView from "../newSrc/views/ProposalsManagerView";
import CampaignDetailView from "../newSrc/views/CampaignDetailView";
import ScreenDetailView from "../newSrc/views/ScreenDetailView";
// viejo (reemplazado por CampaignDetailView): import CampaignContainer from "../containers/CampaignContainer";
import QuotesContainer from "../containers/QuotesContainer";
import UserSettingsContainer from "../containers/UserSettingsContainer";
import Topbar from "../containers/TopbarContainer";
import NotFoundContainer from "../containers/NotFoundContainer";
import PropTypes from "prop-types";
import UrlEnum from "../constants/UrlEnum";
import { Route, Switch } from 'react-router-dom';
import { getDomain } from "../services/utils";
import CheckCompanyForUserComponent from "./CheckCompanyForUserComponent";

import moment from "moment";
import "moment/locale/es";

moment.locale("es");

document.documentElement.className = getDomain(window.location.hostname)
export default class AppComponent extends Component {
  render() {
    const { userAccount, userUpdate, history } = this.props;
    const user = userAccount && userAccount.user;

    return (
      <AppHolder>
        {user && user.permissions && user.permissions.includes('switch_company') && (
          <CheckCompanyForUserComponent user={user} userUpdate={userUpdate} history={history} location={this.props.location} />
        )}
        <Topbar />
        <Switch>
          <Route exact path="/" component={HomeContainer} />
          <Route exact path="/reload/:url/:msg?" component={HomeContainer} />
          <Route exact path="/login/:token?" component={HomeContainer} />
          <Route exact path="/userSettings" component={UserSettingsContainer} />
          <Route exact path="/map" component={MapContainer} />
          {/* viejo: <Route exact path="/screen/:id" component={ScreenContainer} /> */}
          <Route exact path="/screen/:id" component={ScreenDetailView} />
          <Route exact path="/videoUpload" component={VideoUploadContainer} />
          {/* viejo: <Route exact path="/campaigns" component={CampaignsContainer} /> */}
          <Route exact path="/campaigns" component={CampaignsManagerView} />
          {/* viejo: <Route exact path="/proposals" render={(props) => <CampaignsContainer {...props} onlyProposals={true} />} /> */}
          <Route exact path="/proposals" component={ProposalsManagerView} />
          {/* viejo: <Route exact path="/campaign/:id" component={CampaignContainer} /> */}
          <Route exact path="/campaign/:id" component={CampaignDetailView} />
          <Route exact path="/quotes" component={QuotesContainer} />
          <Route exact path="/campaign/:id/payment" component={PaymentContainer} />
          <Route exact path="/payment/:id" component={PaymentStatusContainer} />

          <Route exact path="/campaignManager" component={CampaignManagerView} />

          <Route exact path="/library" component={AdLibraryView} />

          <Route exact path="*" component={NotFoundContainer} />
        </Switch>
      </AppHolder>
    );
  }
}
